import { apiClient } from '../apiClient';
import { LOGIN_PAGE } from '../settings';

export function logout() {
	return apiClient.post(`logout`);
}

export function redirectToLogin() {
	window.location.replace(LOGIN_PAGE);
}